import { render } from "./PromptVersionsPage.vue?vue&type=template&id=d724bd66"
import script from "./PromptVersionsPage.vue?vue&type=script&lang=js"
export * from "./PromptVersionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__